import { configureStore } from '@reduxjs/toolkit';
import { consentReducer } from './slices/consent.slice';
import { carePortalMiddleware } from './utils/effects-middleware';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
// createStore is a non-cached version of the getStore function.
// this function is used to get the type of the return value so we
// can use that type (RootStore) to properly type the cachedStore variable
const createStore = () =>
  configureStore({
    reducer: {
      consent: consentReducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat([carePortalMiddleware.middleware]),
  });

export const getStore = () => {
  if (!cachedStore) {
    cachedStore = createStore();
  }
  return cachedStore;
};

type ConsentRootStore = ReturnType<typeof createStore>;
let cachedStore: ConsentRootStore = null;

export type ConsentRootState = ReturnType<ConsentRootStore['getState']>;
export type AppDispatch = ConsentRootStore['dispatch'];
